import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';

import { GridConfiguration } from '../../../types/grid-configuration.type';

@Component({
  selector: 'app-lot-add-photo-modal-upload-view',
  templateUrl: './lot-add-photo-modal-upload-view.component.html',
  styleUrls: ['./lot-add-photo-modal-upload-view.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LotAddPhotoModalUploadViewComponent {
  @Input() initialImages: string[] = [];
  @Input() noAuctionList = false;
  @Input() grid: GridConfiguration;
  @Input() itemHeightPx: number;
  @Output() sort = new EventEmitter<void>();
  @Output() images = new EventEmitter<string[]>();
  @Output() uploading = new EventEmitter<boolean>();

  isUploading = false;
  noImages = false;

  imageChanges(images: string[]): void {
    this.noImages = images.length === 0;
    this.images.emit(images);
  }

  uploadingStateChange(uploading: boolean): void {
    this.isUploading = uploading;
    this.uploading.emit(uploading);
  }
}
